import { useCallback, useRef } from "react";

export const useScrollToError = () => {
  const fieldRefs = useRef<Record<string, HTMLElement | null>>({});

  const registerField = useCallback(
    (fieldName: string, element: HTMLElement | null) => {
      if (element) {
        fieldRefs.current[fieldName] = element;
      }
    },
    [],
  );

  const scrollToFirstError = useCallback((errors: Record<string, string[]>) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length === 0) return;

    const firstErrorField = errorFields[0];
    const element = fieldRefs.current[firstErrorField];

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });

      if (
        element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement ||
        element instanceof HTMLSelectElement
      ) {
        setTimeout(() => {
          element.focus();
        }, 300);
      } else {
        const input = element.querySelector(
          "input, textarea, select",
        ) as HTMLInputElement;
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 300);
        }
      }
    }
  }, []);

  const clearRefs = useCallback(() => {
    fieldRefs.current = {};
  }, []);

  return {
    registerField,
    scrollToFirstError,
    clearRefs,
  };
};
